module.exports = __webpack_public_path__ + "img/unitPriceEvaluation_05.e50d6f01.png";